module.exports = __webpack_public_path__ + "static/media/time.e5b689b8.svg";